import { useCallback } from 'react';
import Modeler from 'bpmn-js/lib/Modeler';
import Viewer from 'bpmn-js/lib/Viewer';

type BpmnInstance = Modeler | Viewer;

export const useBpmnInitialization = (isEditPermission: boolean, isProcessDiagram: boolean) => {
  const initializeBpmn = useCallback(
    (container: HTMLElement, isCompact = false): BpmnInstance => {
      const commonConfig = {
        container,
        height: '100%',
        width: '100%',
        position: isProcessDiagram ? 'relative' : 'absolute',
      };

      const textRendererConfig = {
        defaultStyle: {
          fontSize: '10px',
          lineHeight: '1.7',
        },
        layout: {
          preRender: true,
          wrap: true,
          maxChar: 50,
        },
        defaultSize: {
          width: isCompact ? 450 : 500,
          maxWidth: isCompact ? 400 : 450,
          height: isCompact ? 400 : 500,
        },
      };

      if (isEditPermission) {
        return new Modeler({
          ...commonConfig,
          propertiesPanel: {
            parent: '#properties-panel',
          },
          additionalModules: [],
          palette: { open: true },
          contextPad: { open: true },
          textRenderer: textRendererConfig,
          zoomScroll: {
            enabled: true,
            pinchZoom: true,
            scrollZoom: true,
            zoomSpeed: 0.1,
            pinchZoomEnabled: true,
            minimumZoom: 0.2,
            maximumZoom: 4,
          },
          moveCanvas: { enabled: true },
          canvas: { deferUpdate: false },
        });
      }

      return new Viewer({
        ...commonConfig,
        textRenderer: textRendererConfig,
        zoomScroll: {
          enabled: true,
          pinchZoom: true,
          scrollZoom: false,
        },
        moveCanvas: { enabled: true },
      });
    },
    [isEditPermission, isProcessDiagram]
  );

  return { initializeBpmn };
};
